import React from "react";
import LeftBar from "../../Home/left-side-bar";
import UserActivityMainContent from "./main-content";
import UserLeftBar from "./user-left-bar";
import { useLocation } from "react-router-dom";

const UserActivityPage = () => {
  const location = useLocation();
  return (
    <div className="bg-gray-100 h-full relative">
      <div className="mx-5 grid grid-cols-1 lg:grid-cols-12 gap-4 pt-5">
        {/* Left Sidebar */}
        <UserLeftBar />

        {/* Main Content */}
        <UserActivityMainContent tabState={location.state} />

        {/* Right Sidebar */}
        <LeftBar />
      </div>
    </div>
  );
};

export default UserActivityPage;
